export const LIST_EVENT = 'LIST_EVENT'
export const LIST_EVENT_INFINITE = 'LIST_EVENT_INFINITE'
export const DETAIL_EVENT = 'DETAIL_EVENT'
export const TOTAL_EVENT = 'TOTAL_EVENT'
